<template>
  <block-tile
    :asset="asset"
    :asset-type="type"
    :asset-completed="asset.completedState(assetState)"
    :featured-image="displayAttachment"
    :metadata="metadata"
    :metadata-icon-name="icon"
    :source="source"
    :state="assetState"
    :title="title"
    @tile-clicked="$emit('tile-clicked')"
  />
</template>

<script>
import BlockTile from '@/components/ui/blockTile';

export default {
  name: 'AssetBlockTile',
  components: { BlockTile },
  props: {
    asset: {
      type: Object,
    },
    assetState: {
      type: Object,
      default: () => ({}),
    },
    displayAttachment: {
      type: Object,
    },
    source: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['tile-clicked'],
  computed: {
    icon() {
      return this.asset?.icon;
    },
    metadata() {
      return this.asset.cardMetadata?.(this.$store);
    },
    title() {
      return this.asset?.assetTitle;
    },
    type() {
      return this.asset?.assetType;
    },
  },
};
</script>

<style>

</style>
